import { createApp, h } from 'vue'
import Inquiry from '../inquiry'
import Input from '../components/input'
import Select from '../components/select'
import Textarea from '../components/textarea'
import GoogleForJobs from '../components/GoogleForJobs'
// IE11だけ動かないので今後使う可能性を考慮してPending
//import OpenStreetMap from '../components/OpenStreetMap'
import Header from '../components/Header'
import Footer from '../components/Footer'
import InformationTable from '../components/order/InformationTable'
import PageHeader from '../components/order/PageHeader'
import router from '../router/inquiry'
import store from '../store/inquiry'
import axios from 'axios'

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('inquiry_form') || document.getElementById('inquiry_thanks')

  // Viewから情報を取得
  const props = JSON.parse(el.getAttribute('data-props')) || {}

  // CSRF-Tokenをセット
  axios.defaults.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

  // 量が増えた場合は考慮が必要
  const app = createApp({
    render: () => h(Inquiry, props)
  })
  app.component('vue-input', Input)
  app.component('vue-select', Select)
  app.component('vue-textarea', Textarea)
  app.component('vue-header', Header)
  app.component('vue-footer', Footer)
  app.component('information-table', InformationTable)
  app.component('page-header', PageHeader)
  app.component('vue-google-for-jobs', GoogleForJobs)
  // IE11だけ動かないので今後使う可能性を考慮してPending
  //app.component('vue-open-street-map', OpenStreetMap)
  app.use(store)
  app.use(router)
  app.mount(el)
})
